// DashboardConfig.js
import React, { useState, useEffect } from "react";
import {
  FormControlLabel,
  Checkbox,
  Box,
  Button,
  Typography,
  Divider,
  Radio,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setDashboardConfig } from "../../redux/slices/dashboardConfig";
import WidgetDesignCard from "../../components/DashboardConfig/WidgetDesignCard";
import { toast } from "react-toastify";

const DashboardConfig = () => {
  const dashboardConfig = useSelector(
    (state) => state.dashboardConfig.dashboardConfig
  );

  const [config, setConfig] = useState(dashboardConfig);
  const dispatch = useDispatch();

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setConfig((prevConfig) => ({
      ...prevConfig,
      [name]: checked,
    }));
  };

  const handleRadioButtonChange = (event) => {
    const { name, value } = event.target;
    setConfig((prevConfig) => ({
      ...prevConfig,
      [name]: value,
    }));
  };

  const handleSave = () => {
    dispatch(setDashboardConfig(config));
    toast.success("Configuration has been saved!");
  };

  return (
    <Box>
      <Box
        sx={{
          border: "1px solid lightgrey",
          borderRadius: "10px",
          padding: "20px",
          marginY: "20px",
        }}
      >
        <Typography marginBottom={"20px"} variant="h6">
          Dashboard widgets layout
        </Typography>
        <Divider sx={{ margin: "20px -20px" }} />
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box>
            <FormControlLabel
              control={
                <Radio
                  checked={config?.showSummaryAtPosition === "start"}
                  onChange={handleRadioButtonChange}
                  name="showSummaryAtPosition"
                  value={"start"}
                  sx={{ marginTop: 2 }}
                />
              }
              sx={{ display: "flex", alignItems: "flex-start" }}
              label={
                <WidgetDesignCard
                  src={"/assets/icons/widget-design-layout-1.svg"}
                />
              }
            />
          </Box>
          <Box>
            <FormControlLabel
              control={
                <Radio
                  checked={config.showSummaryAtPosition === "middle"}
                  onChange={handleRadioButtonChange}
                  name="showSummaryAtPosition"
                  value={"middle"}
                  sx={{ marginTop: 2 }}
                />
              }
              sx={{ display: "flex", alignItems: "flex-start" }}
              label={
                <WidgetDesignCard
                  src={"/assets/icons/widget-design-layout-3.svg"}
                />
              }
            />
          </Box>
          <Box>
            <FormControlLabel
              control={
                <Radio
                  checked={config.showSummaryAtPosition === "end"}
                  onChange={handleRadioButtonChange}
                  name="showSummaryAtPosition"
                  value={"end"}
                  sx={{ marginTop: 2 }}
                />
              }
              sx={{ display: "flex", alignItems: "flex-start" }}
              label={
                <WidgetDesignCard
                  src={"/assets/icons/widget-design-layout-2.svg"}
                />
              }
            />
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          border: "1px solid lightgrey",
          borderRadius: "10px",
          padding: "20px",
        }}
      >
        <Typography marginBottom={"20px"} variant="h6">
          Dashboard widgets library
        </Typography>
        <Divider sx={{ margin: "20px -20px" }} />
        <Box
          sx={{
            border: "1px solid lightgrey",
            borderRadius: "10px",
            padding: "20px",
            marginY: "20px",
          }}
        >
          <Typography marginBottom={"20px"} variant="h6">
            Content Performance
          </Typography>

          <FormControlLabel
            control={
              <Checkbox
                checked={config.showContentViewBarGraph}
                onChange={handleCheckboxChange}
                name="showContentViewBarGraph"
              />
            }
            label="Total Content Views"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={config.showAverageWatchTimeChart}
                onChange={handleCheckboxChange}
                name="showAverageWatchTimeChart"
              />
            }
            label="Average Watch Time "
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={config.showContentApprovalTimeGraph}
                onChange={handleCheckboxChange}
                name="showContentApprovalTimeGraph"
              />
            }
            label="Content Approval Time "
          />
        </Box>
        <Box
          sx={{
            border: "1px solid lightgrey",
            borderRadius: "10px",
            padding: "20px",
          }}
        >
          <Typography marginBottom={"20px"} variant="h6">
            Audience Performance
          </Typography>

          <FormControlLabel
            control={
              <Checkbox
                checked={config.showAudienceChart}
                onChange={handleCheckboxChange}
                name="showAudienceChart"
              />
            }
            label={"Audience Growth With Time"}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={config.showContentEngagementBarGraph}
                onChange={handleCheckboxChange}
                name="showContentEngagementBarGraph"
              />
            }
            label="Audience Demographics-(Age)"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={config.showAudienceByGender}
                onChange={handleCheckboxChange}
                name="showAudienceByGender"
              />
            }
            label="Audience Demographics-(Gender)"
          />
        </Box>
      </Box>
      <Button
        sx={{ marginY: "20px", textTransform: "capitalize" }}
        variant="contained"
        onClick={handleSave}
      >
        Save Configuration
      </Button>
    </Box>
  );
};

export default DashboardConfig;
